import Vue from 'vue'
import App from './App'
import store from './store/store'
import _ from 'lodash'

Vue.config.productionTip = false


// Icon
import Icon from './components/ui/Icon.vue'
Vue.component('icon', Icon);

// Key
import Key from './components/ui/Key.vue'
Vue.component('key', Key);

// Sounds
import sounds from './core/Sounds.js'
sounds.init()
window.sounds = sounds


new Vue({
	store,
	el: '#app',
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js